<template>
  <div class="grid-y flex-grow divide-y settings-page">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RouterTabs from '@/components/RouterTabs.vue';
import { ADMIN_PERMISSIONS, canAccess } from '@/access/adminAccess';

export default {
  components: {
    RouterTabs,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    tabs() {
      return [
        { title: 'Порог отключения', push: { name: 'settings.limit' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'Заказы', push: { name: 'settings.orders' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'Правовые документы', push: { name: 'settings.legal' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'Админ аккаунты', push: { name: 'settings.admins' }, permission: ADMIN_PERMISSIONS.ADMINS },
        { title: 'Регионы работы', push: { name: 'settings.regions' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'Коммуникации', push: { name: 'settings.sms' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'Шаблоны', push: { name: 'settings.templates' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'E-mail', push: { name: 'settings.email' }, permission: ADMIN_PERMISSIONS.SETTINGS },
        { title: 'Аналитика', push: { name: 'settings.analytics' }, permission: ADMIN_PERMISSIONS.ANALYTICS },
        { title: 'Мониторинг', push: { name: 'settings.monitoring' }, permission: ADMIN_PERMISSIONS.MONITORING },
        { title: 'База данных', push: { name: 'settings.db' }, permission: ADMIN_PERMISSIONS.DATABASE },
      ].filter((tab) => canAccess(this.user, tab.permission));
    },
  },
};
</script>
